import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComboService, FormContainerConfig, IForm, MrfFormComponent } from '@eng/morfeo';

@Component({
  selector: 'app-segnalazione',
  templateUrl: './segnalazione.component.html',
  styleUrls: ['./segnalazione.component.css']
})
export class SegnalazioneComponent  {
  @ViewChild(MrfFormComponent) formRef: MrfFormComponent;
  public formJson: IForm = {"components" : []}
  public formSubmit: FormContainerConfig = {
    showSubmit: true,
    submitLabel: 'Invia',
    submitCallback: (f: NgForm) => {
      console.log(f.form.value);
    },
    showReset: true,
    resetLabel: "RESET",
  }

  onSaveEvent() {
    console.log(this.formRef.f.form.value);
  }

  onResetEvent() {
    this.formRef.f.form.reset();
  }

  constructor(private router: Router, 
    private route: ActivatedRoute,
    private comboService: ComboService
    ) { }

  ngOnInit(): void {
    /*this.formJson = {
      "components": [
        {
          "label": "Select example",
          "key": "example-select",
          "type": "select", 
          "data": {
            "values": [
              {"label":"2","value":"DUE"},
              {"label":"3","value":"TRE"}
            ]
          },
          "dataSrc": "values",
          "suffix": "",
          "hidden": false,
          "defaultValue": "002",
          "validate": {
            "custom": ""
          },
          "input": true,
          "valueProperty": "value",
          "labelProperty": "label"
        }
      ]
    };*/

    this.formJson =
    {
      components: [
        {
          type: 'select',
          label: 'select',
          key: 'select1',
          dataSrc: 'values',
          data: {
            values: [
              {
                label: 'primi 4',
                value: '1'
              },
              {
                label: 'altri 4',
                value: '2'
              }
            ]
          }
        },
        {
          type: 'select',
          label: 'select',
          key: 'select2',
          dataSrc: 'url',
          data: {
            url: 'https://jsonplaceholder.typicode.com/users',
            params: {
              _limit: 4
            },
            configurableParams: {
              _page: 'select1'
            }
          },
          valueProperty: 'id',
          labelProperty: 'name'
        },]
    }
  }

  
  public ngAfterViewInit() {
    this.formRef.formReadyEvent.subscribe(f => {
      console.log('adesso la form è pronta...');
      console.log(f.form.value);
      
      console.log('adesso valorizziamo');
      this.comboService.setList('select2', [{"label":"1","value":"UNO"}]);

      this.comboService.collectionChange.subscribe( comboValues => {
        console.log("cambiamenti delle opzioni");
        console.log(comboValues);
      });
    });
  }
  salva() {
    console.log(this.formRef.f.form.value);
  }

  setta() {
      this.formRef.f.setValue(
        {"select2" : "001"}
      )
  }

  modificaLista() {
    console.log("Adesso provo a modificare la lista...");
    //this.formRef.comboService.setList("example-select", [{"label":"1","value":"UNO"}]);
    this.comboService.setList("select2", [{"label":"1","value":"UNO"}]);
  }
}
